import React, { useState, useEffect, useCallback } from 'react';
import ScGrid from '../ScGrid';
import ScModal from '../ScModal';
import ScSpinner from '../ScSpinner';
import { fetchActivities, createActivity, updateActivity } from '../../studyConfigurationApi';

const DEFAULT_ACTIVITY_NAME = 'General';

const ActivitiesTab = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [editId, setEditId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchActivities();
      setRows(res.data || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to load activities.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      if (editId) await updateActivity(editId, { activityNo: editId, activityName: name });
      else await createActivity({ activityName: DEFAULT_ACTIVITY_NAME });
      setModalOpen(false);
      load();
    } catch (e) {
      setError(e.response?.data?.error || 'Save failed.');
    }
  };

  if (loading) return <ScSpinner />;
  return (
    <div>
      {error && <div className="sc-alert sc-alert-error">{error}</div>}
      <div className="sc-toolbar">
        <button type="button" className="sc-btn sc-btn-primary" onClick={() => { setEditId(null); setName(DEFAULT_ACTIVITY_NAME); setModalOpen(true); }}>Add Activity</button>
      </div>
      <ScGrid columns={[{ key: 'activityName', label: 'Activity' }]} rows={rows}
        onEdit={(r) => { setEditId(r.activityNo); setName(r.activityName); setModalOpen(true); }} />
      <ScModal open={modalOpen} title={editId ? 'Edit Activity' : 'Add Activity'} onClose={() => setModalOpen(false)}
        footer={<><button type="button" className="sc-btn sc-btn-secondary" onClick={() => setModalOpen(false)}>Cancel</button><button type="button" className="sc-btn sc-btn-primary" onClick={save}>Save</button></>}>
        <div className="sc-form-row">
          <label>Name</label>
          <input
            value={editId ? name : DEFAULT_ACTIVITY_NAME}
            disabled={!editId}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </ScModal>
    </div>
  );
};

export default ActivitiesTab;
